<template>
    <div v-if="!this.appData.loaded">
        <!-- now data loading -->
    </div>

    <div v-else-if="!appData.tenantAdminUser">
        <div class="object-inner-table">
            <table width=100%>
                <td class="object-item">{{$t('message.info_needs_tenant_admin_privilege')}}</td>
            </table>
        </div>
    </div>

    <div v-else-if="enableAiAppSetting">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_ai_setting'"></div>
            <div class="object-titlebox-right" style="padding-right:20px">
                <button class="transparent" type="button" v-on:click="showDialog.add = true">
                    <img src="@/assets/add_user.svg" alt=""/>
                    <span class="normal-command-text" v-t="'message.common_action_add'"></span>
                </button>
            </div>
        </div>
        <table width="100%" cellpadding=0 cellspacing=0>
            <thead>
                <tr>
                    <th class="header-item" style="width:30%" v-t="'message.item_display_name'"></th>
                    <th class="header-item" style="width:28%" v-t="'message.item_type'"></th>
                    <th class="header-item" style="width:12%" v-t="'message.item_group'"></th>
                    <th class="header-item" style="width:10%" v-t="'message.common_action_edit'"></th>
                    <th class="header-item" style="width:10%" v-t="'message.common_action_delete'"></th>
                    <th class="header-item" style="width:10%" v-t="'message.action_talk_detail'"></th>
                </tr>
            </thead>

            <AiAppDefinitionSettingRow
                v-for="processorDefinition in processorDefinitionList"
                :key="processorDefinition.id"
                :type = TYPE_PROCESSOR
                :definition="processorDefinition"
                @modify="modifyAiAppSetting"
                @delete="deleteAiAppSetting"
                @assign="assignRequest"
            />

            <AiAppDefinitionSettingRow
                v-for="serviceInformation in serviceInformationList"
                :key="serviceInformation.serviceName + '-' + serviceInformation.id"
                :type = TYPE_SERVICE_INFORMATION
                :definition="serviceInformation"
                @modify="modifyAiAppSetting"
                @delete="deleteAiAppSetting"
                @assign="assignRequest"
            />
        </table>

        <AiAppSettingDefinitionAdd
            v-if="showDialog.add"
            :processorTemplateList="$root.store.processorTemplateList"
            @save="addNewAiAppSetting"
            @cancel="showDialog.add=false"
        />
    </div>

    <div v-else>
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.item_ai_setting'"></div>
        </div>
        <div class="default-message" style="padding-top: 10vh;">
            <span v-t="'message.info_ai_app_plan_restriction'"></span><br><br>
            <div v-if="showAskSupport">
                <span v-t="'message.info_ai_app_support_request1'"></span>
                <a href="https://www.buddycom.net/ja/inquiry.html" target="_blank"><span v-t="'message.info_ai_app_support_request2'"></span></a>
                <span v-t="'message.info_ai_app_support_request3'"></span>
                <br><br><br><br>
            </div>
            <span v-t="'message.info_ai_app_current_service'"></span><br>
            <span v-t="'message.info_ai_app_manual_info1'"></span>
            <router-link to="/manual">
                <span v-t="'message.menu_manual'"></span>
            </router-link>
            <span v-t="'message.info_ai_app_manual_info2'"></span>
            <br><br>
            <table style="margin-left: auto; margin-right: auto;">
                <tr>
                    <td v-for="processorTemplate in $root.store.processorTemplateList" style="padding-top:10px;padding-bottom:10px">
                        <el-card shadow="never" style="{ text-align:center; padding: 0; width: 120px; border-style: none; }">
                            <img :src="getIcon(processorTemplate)" height="40px"  alt=""/><br>
                            <span>{{ getLocaledText(processorTemplate.template.name) }}</span>
                        </el-card>
                    </td>
                </tr>
            </table><br><br>
            <template v-if="showGuide">
                <div v-if="isWebTenant">
                    <el-button class="dialog-ok-button" style="margin-top: 4pt; margin-bottom: 4pt" @click="$router.push('license')" v-t="'message.info_ai_app_change_plan'"></el-button>
                </div>
                <div v-else>
                    <span v-t="'message.info_ai_app_guide_purchase_origin'"></span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import processorTemplateUtil from "@/components/pc/setting/ai-app/AiAppSettingUtil";
import AiAppSettingUtility from "@/components/pc/setting/ai-app/AiAppSettingUtility";
import AiAppSettingDefinitionAdd from "@/components/pc/setting/ai-app/AiAppSettingDefinitionAdd";
import AiAppDefinitionSettingRow from "@/components/pc/setting/ai-app/AiAppSettingDefinitionRow";

export default {
    mixins: [AiAppSettingUtility],

    components: { AiAppSettingDefinitionAdd, AiAppDefinitionSettingRow },

    props: [ 'appData' ],

    data() {
        return {
            processorDefinitionList: null,
            serviceInformationList: null,
            selectedProcessorDefinition: null,
            showDialog: {
                add: false
            },
            baseTemplateText: commonUtil.getMessageText(this.$i18n, 'title_ai_base_template'),
            displayNameText: commonUtil.getMessageText(this.$i18n, 'title_ai_display_name'),
        };
    },

    computed: {
        TYPE_PROCESSOR () {
            return AiAppSettingUtility.TYPE_PROCESSOR
        },
        TYPE_SERVICE_INFORMATION () {
            return AiAppSettingUtility.TYPE_SERVICE_INFORMATION
        },

        enableAiAppSetting() {
            return (this.appData.tenantOption & constants.AI_APP_COOPERATION_TRIAL) !== 0
        },

        isWebTenant() {
            return this.appData.basicContract.billingType === constants.BILLING_CREDIT_CARD
        },

        showGuide() {
            switch (this.appData.basicContract.planType) {
                case constants.LICENSE_PLAN_TALK_LITE:
                case constants.LICENSE_PLAN_LIVE_LITE:
                case constants.LICENSE_PLAN_LITE:
                case constants.LICENSE_PLAN_STANDARD:
                    return true
                case constants.LICENSE_PLAN_TALK_ENT:
                case constants.LICENSE_PLAN_LIVE_ENT:
                case constants.LICENSE_PLAN_ENTERPRISE:
                case constants.LICENSE_PLAN_SEPARATE:
                    return false
            }
        },

        showAskSupport() {
            switch (this.appData.basicContract.planType) {
                case constants.LICENSE_PLAN_TALK_LITE:
                case constants.LICENSE_PLAN_LIVE_LITE:
                case constants.LICENSE_PLAN_LITE:
                case constants.LICENSE_PLAN_STANDARD:
                    return false;
                case constants.LICENSE_PLAN_TALK_ENT:
                case constants.LICENSE_PLAN_LIVE_ENT:
                case constants.LICENSE_PLAN_ENTERPRISE:
                case constants.LICENSE_PLAN_SEPARATE:
                    return true;
            }
        },
    },

    watch: {
        'appData.loaded': function (newVal) {
            if (newVal) {
                this.processorDefinitionList = this.$root.store.processorDefinitionList
                this.serviceInformationList = this.$root.store.serviceInformationList.filter(serviceInformation => serviceInformation.serviceName === AiAppSettingUtility.SERVICE_NAME_GIGARAKU_CAMERA)
            }
        }
    },

    created() {
        if (this.appData.loaded) {
            if (this.$root.store.needRefreshOfProcessorTemplate) {
                this.refreshAndSetProcessorDefinitionList();
            } else {
                this.processorDefinitionList = this.$root.store.processorDefinitionList;
            }
            this.serviceInformationList = this.$root.store.serviceInformationList.filter(serviceInformation => serviceInformation.serviceName === AiAppSettingUtility.SERVICE_NAME_GIGARAKU_CAMERA)
        }
    },

    methods: {
        async refreshAndSetProcessorDefinitionList() {
            await this.$root.store.actions.fetchProcessorTemplatesAndDefinitions();
            this.processorDefinitionList = this.$root.store.processorDefinitionList;
        },
        async addNewAiAppSetting(path, param, defaultErrorHandler) {
            try {
                const res = await server.post(path, param)

                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        let promises = [
                            this.$root.store.actions.fetchProcessorTemplatesAndDefinitions(),
                            this.$root.store.actions.fetchServiceInformations(),
                        ];

                        try {
                            await Promise.all(promises);
                            commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "info_created_ai_setting"));
                        } catch(error) {
                            commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","addNewProcessorDefinition").replace("{code}",res.data.status));
                        }

                        this.processorDefinitionList = this.$root.store.processorDefinitionList;
                        this.serviceInformationList = this.$root.store.serviceInformationList;
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(this, 'Error', commonUtil.getMessageText(this.$i18n, "error_cannot_create_display_name_duplicate"));
                        break;
                    case constants.STATUS_ERROR_INVALID_PARAMETER:
                        commonUtil.notifyMessage(this, 'Error', commonUtil.getMessageText(this.$i18n, "error_cannot_create_invalid_parameter"));
                        break;
                    default:
                        if (defaultErrorHandler !== null) {
                            defaultErrorHandler(res.data);
                        } else {
                            commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","addNewProcessorDefinition").replace("{code}",res.data.status));
                        }
                        break;
                }
            } catch ( error ) {
                commonUtil.putExceptionErrorMessage(this, "addNewAiAppSetting", error);
            }

            this.showDialog.add = false;
        },

        async deleteAiAppSetting(path, param) {
            try {
                const res = await server.post(path, param)

                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        let promises = [
                            this.$root.store.actions.fetchProcessorTemplatesAndDefinitions(),
                            this.$root.store.actions.fetchServiceInformations(),
                        ];

                        try {
                            await Promise.all(promises);
                            commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "info_deleted_ai_setting"));
                        } catch(error) {
                            commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","deleteProcessorDefinition").replace("{code}",res.data.status));
                        }

                        this.processorDefinitionList = this.$root.store.processorDefinitionList;
                        this.serviceInformationList = this.$root.store.serviceInformationList;
                        break;
                    case constants.STATUS_ERROR_STILL_ASSIGNED:
                        commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_ai_still_assigned"));
                        break;
                    default:
                        commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","deleteProcessorDefinition").replace("{code}",res.data.status));
                        break;
                }
            } catch ( error ) {
                commonUtil.putExceptionErrorMessage(this, "deleteAiAppSetting", error);
            }
        },

        async modifyAiAppSetting(path, param, defaultErrorHandler) {
            try {
                const res = await server.post(path, param)

                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        let promises = [
                            this.$root.store.actions.fetchProcessorTemplatesAndDefinitions(),
                            this.$root.store.actions.fetchServiceInformations()
                        ];

                        try {
                            await Promise.all(promises);
                            commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "info_modified_ai_setting"));
                        } catch(error) {
                            commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}", "modifyAiAppSetting").replace("{code}", res.data.status));
                        }

                        this.processorDefinitionList = this.$root.store.processorDefinitionList;
                        this.serviceInformationList = this.$root.store.serviceInformationList;
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(this, 'Error', commonUtil.getMessageText(this.$i18n, "error_cannot_edit_display_name_duplicate"));
                        break;
                    case constants.STATUS_ERROR_INVALID_PARAMETER:
                        commonUtil.notifyMessage(this, 'Error', commonUtil.getMessageText(this.$i18n, "error_cannot_edit_invalid_input"));
                        break;
                    default:
                        if (defaultErrorHandler !== null) {
                            defaultErrorHandler(res.data);
                        } else {
                            commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","modifyAiAppSetting").replace("{code}", res.data.status));
                        }
                        break;
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "modifyAiAppSetting", error);
            }
        },

        async assignRequest(path, param, defaultErrorHandler) {
            try {
                const res = await server.post(path, param)

                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, 'Success', commonUtil.getMessageText(this.$i18n, "info_assign_processor_definition"));
                        break;
                    case constants.STATUS_ERROR_BATCH_PROCESS:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_cannot_assign_processor_definition"));
                        break;
                    default:
                        if (defaultErrorHandler !== null) {
                            defaultErrorHandler(res.data)
                        } else {
                            commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "assignRequest").replace("{code}", res.data.status));
                        }
                        break;
                }
            } catch ( error ) {
                commonUtil.putExceptionErrorMessage(this, "assignRequest", error);
            }
        },

        getLocaledText(item) {
            return processorTemplateUtil.getLocaledText(this.$i18n, item);
        },

        getIcon(template) {
            if ('iconUrl' in template.template) {
                return template.template.iconUrl;
            }
            return processorTemplateUtil.getDefaultIconUrl();
        },
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.header-value {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #848991;
    font-size: 12px;
}

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}

.select-setting {
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
    width:35%;
    height:100%;
    valign:top
}
.vertical-line-addition {
    height: 100vh;
    margin: 0;
    padding: 0;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.header-item {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    text-align: left;
    font-size: 12px;
    background-color: #f6f6f6;
    color: #848991;
}

button.transparent img {
    display: inline;
    vertical-align: middle;
    height: 18px;
}

</style>
